import { C as r } from "./codemirror.es.js";
import "./show-hint.es.js";
import { Position as d, getAutocompleteSuggestions as m } from "graphql-language-service";
import "./codemirror.es2.js";
r.registerHelper("hint", "graphql", (n, c) => {
  const { schema: i, externalFragments: p, autocompleteOptions: u } = c;
  if (!i)
    return;
  const s = n.getCursor(), o = n.getTokenAt(s), a = o.type !== null && /"|\w/.test(o.string[0]) ? o.start : o.end, g = new d(s.line, a), t = {
    list: m(i, n.getValue(), g, o, p, u).map((e) => {
      var l;
      return {
        text: (l = e == null ? void 0 : e.rawInsert) !== null && l !== void 0 ? l : e.label,
        type: e.type,
        description: e.documentation,
        isDeprecated: e.isDeprecated,
        deprecationReason: e.deprecationReason
      };
    }),
    from: { line: s.line, ch: a },
    to: { line: s.line, ch: o.end }
  };
  return t != null && t.list && t.list.length > 0 && (t.from = r.Pos(t.from.line, t.from.ch), t.to = r.Pos(t.to.line, t.to.ch), r.signal(n, "hasCompletion", n, t, o)), t;
});
//# sourceMappingURL=hint.es.js.map
